<template>
  <p v-if="anexos.length" class="manifestacao-anexos">
    <b-icon icon="paperclip" size="is-small" class="manifestacao-anexos-icon" />
    <template v-for="(anexo, index) in anexos">
      <a :key="anexo.id || `${anexo.arquivo}-${index}`" :href="anexo.arquivo | fileServer" download>
        {{ rotuloAnexo(anexo) }}
      </a>
      <span
        v-if="index < anexos.length - 1"
        :key="`sep-${anexo.id || index}`"
        class="manifestacao-anexos-sep"
      >
        |
      </span>
    </template>
  </p>
</template>

<script>
import { fileServer } from '@/utils/functions';

export default {
  name: 'ManifestacaoAnexosLista',
  props: {
    anexos: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  filters: {
    fileServer,
  },
  methods: {
    extensaoAnexo(anexo) {
      const referencia = anexo.nome || anexo.arquivo || '';
      const partes = referencia.split('.');
      if (partes.length < 2) return '';
      return partes.pop().toLowerCase();
    },
    rotuloAnexo(anexo) {
      const nome = (anexo.nome || '').trim();
      if (!nome) {
        return anexo.arquivo || '';
      }
      if (nome.includes('.')) {
        return nome;
      }
      const extensao = this.extensaoAnexo(anexo);
      return extensao ? `${nome}.${extensao}` : nome;
    },
  },
};
</script>

<style src="@/styles/manifestacao.scss" lang="scss" scoped />
